import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messageService = inject(MessageService);

  public success(msg: string, title: string = 'Éxito'): void {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: msg,
    });
  }

  public error(msg: string, title: string = 'Error'): void {
    this.messageService.add({
      severity: 'error',
      summary: title,
      detail: msg,
    });
  }

  public info(msg: string, title: string = 'Información'): void {
    this.messageService.add({
      severity: 'info',
      summary: title,
      detail: msg,
    });
  }

  public warning(msg: string, title: string = 'Aviso'): void {
    this.messageService.add({
      severity: 'warn',
      summary: title,
      detail: msg,
    });
  }
}
